import { css } from 'design'

type Props = {
  count: number
  selectedIndex: number
}

export const SlideIndicator = ({ count, selectedIndex }: Props) => {
  return (
    <svg width={(count - 1) * 15 + 8} height={8}>
      {[...Array(count)].map((_, index) => (
        <circle
          key={index}
          cx={index * 15 + 4}
          cy={4}
          r={4}
          className={circleStyles({ selected: index === selectedIndex })}
        />
      ))}
    </svg>
  )
}

const circleStyles = css({
  fill: '$grey300',

  variants: {
    selected: {
      true: {
        fill: '$grey700',
      },
    },
  },
})
